import { render, staticRenderFns } from "./AdminSetups.vue?vue&type=template&id=5d85d5df&"
import script from "./AdminSetups.vue?vue&type=script&lang=js&"
export * from "./AdminSetups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports